export default __webpack_public_path__ + "static/media/bottlez.01c78837.jpg";